import { render, staticRenderFns } from "./batchCleanWxId.vue?vue&type=template&id=96ca9382&scoped=true"
import script from "./batchCleanWxId.vue?vue&type=script&lang=js"
export * from "./batchCleanWxId.vue?vue&type=script&lang=js"
import style0 from "./batchCleanWxId.vue?vue&type=style&index=0&id=96ca9382&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ca9382",
  null
  
)

export default component.exports